// 模板 4：智慧零售与新消费平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner1.png'),
        path: '',
        title: '全渠道零售运营中台',
        content:
          '打通门店、电商与私域渠道数据，帮助品牌构建统一的消费者运营体系。'
      },
      {
        img: require('@/assets/img/banner_2.jpg'),
        path: '',
        title: '敏捷营销自动化',
        content:
          '基于用户分群与行为触达的自动化营销流程，让运营更高效。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '消费者数据资产平台',
      subtitle: '/ Retail Customer Data Platform',
      paragraphs: [
        '围绕会员、订单、商品与触点数据构建统一 ID 体系，为精细化运营提供扎实的数据基础。',
        '通过画像标签与行为评分模型，帮助品牌识别高价值人群与潜力客户，指导差异化运营策略。'
      ],
      buttonText: '申请零售行业方案'
    },
    contact: {
      title: '新消费品牌的数字化伙伴',
      subTitle: '让每一次用户触达都更有价值',
      buttonText: '沟通数字化规划'
    },
    customers: [
      {
        logo: require('@/assets/img/logo_kk.png'),
        title: '新零售品牌 · CMO',
        content:
          '通过统一的数据平台，我们可以清楚地看到不同渠道的用户构成和转化效果，营销预算投入更加精准。'
      }
    ],
    advantages: [
      {
        icon: require('@/assets/img/logo_white.png'),
        title: '理解新消费场景',
        html: '<p>深度参与新消费品牌项目</p>沉淀完整增长方法论'
      },
      {
        icon: require('@/assets/img/tel.png'),
        title: '灵活迭代能力',
        html: '<p>快速响应业务变化</p>支持高频营销活动与新品上市'
      }
    ]
  },
  company: {
    name: '灵汇零售科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__专注服务新零售与新消费品牌，围绕会员运营、全渠道订单与仓配履约提供一体化解决方案。',
      '公司核心团队来自知名互联网与零售企业，既懂技术也懂生意，以数据驱动帮助品牌持续提升单客价值。'
    ]
  },
  news: [
    {
      id: 'R01',
      title: '助力某新茶饮品牌构建私域运营体系',
      introduce:
        '通过会员中台与小程序商城项目，帮助客户打通线上线下会员资产，实现多门店统一积分与优惠权益运营。',
      date: '08-16',
      year: '2024'
    },
    {
      id: 'R02',
      title: '推出新品类精细化选品分析模块',
      introduce:
        '基于历史销售与用户反馈数据，提供新品类选品评分能力，帮助品牌在多品类扩展过程中降低试错成本。',
      date: '04-09',
      year: '2024'
    },
    {
      id: 'R03',
      title: '联合品牌举办用户增长实战分享会',
      introduce:
        '聚焦拉新、留存与复购三大主题，拆解不同行业的用户增长实战路径，现场反响热烈。',
      date: '11-22',
      year: '2023'
    },
    {
      id: 'R04',
      title: '上线全渠道订单异常智能预警',
      introduce:
        '通过规则与模型结合的方式，对订单履约过程中的超时、错配与退换货高发等异常进行自动预警。',
      date: '06-01',
      year: '2023'
    },
    {
      id: 'R05',
      title: '加入新消费品牌服务生态联盟',
      introduce:
        '与多家品牌服务机构共同打造新消费领域的数字化服务生态，为品牌提供一站式解决方案。',
      date: '10-18',
      year: '2022'
    }
  ],
  software: {
    smartTown: {
      title: '门店与电商一体化运营系统',
      sections: [
        {
          heading: '1. 门店数字化运营',
          content:
            '为线下门店提供收银、库存与会员一体化能力，实时回传经营数据，为总部决策提供依据。'
        },
        {
          heading: '2. 电商与私域统一管理',
          content:
            '集中管理多平台店铺与小程序商城，统一配置价格、活动与库存，减少重复操作。'
        },
        {
          heading: '3. 会员积分与权益体系',
          content:
            '构建跨渠道统一的会员等级与积分体系，实现积分商城、权益包与生日关怀等玩法。'
        },
        {
          heading: '4. 门店员工激励工具',
          content:
            '通过导购二维码、员工业绩看板等工具，激发一线团队参与私域建设与用户运营。'
        }
      ]
    },
    bigData: {
      title: '零售数据分析与洞察平台',
      sections: [
        {
          heading: '1. 商品与品类表现分析',
          desc:
            '通过销量、毛利与动销率等指标，帮助品牌识别核心商品与长尾尾货，指导选品与补货决策。'
        },
        {
          heading: '2. 用户生命周期运营',
          desc:
            '基于首购、复购与流失等行为，将用户划分为不同生命周期阶段，匹配对应运营策略。'
        },
        {
          heading: '3. 渠道投放效果评估',
          desc:
            '打通广告投放与订单数据，评估不同渠道与素材的实际转化效果，为投放优化提供依据。'
        },
        {
          heading: '4. 活动复盘与策略优化',
          desc:
            '沉淀标准化活动复盘报表模板，从 ROI、用户结构与拉新成本等多个维度评估活动效果。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '零售数字化诊断',
      engTitle: 'Retail Consulting',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '会员运营体系搭建',
      engTitle: 'Loyalty Program Design',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '全渠道系统实施',
      engTitle: 'Omni-Channel Delivery',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '增长陪跑服务',
      engTitle: 'Growth Partner',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '零售数据运营经理',
    responsibilities: [
      '负责品牌客户的经营数据分析与用户运营策略制定；',
      '基于数据洞察提出可落地的增长方案，并推动在项目中执行；',
      '沉淀不同行业的运营方法论，为产品迭代提供输入。'
    ],
    requirements: [
      '具备新零售、电商或品牌方数据运营经验，对增长指标敏感；',
      '熟练使用各类数据分析工具，具备良好的逻辑思维与沟通能力；',
      '对新消费领域保持兴趣，愿意持续学习行业新玩法。'
    ],
    buttonText: '加入我们'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-4.js